/**
 * A Mira tile's formatted value split into its number and the unit after it, so the tile can draw the
 * unit smaller beside the number (Taimoor, 2026-10-30): at the narrowest tile a 40px "20,2 kWh/Tag"
 * broke the unit onto a line of its own and made that tile taller than its neighbours.
 *
 * Works on the finished, translated text, like `MiraNumberTween`: the number is everything up to the
 * last digit ("< 1" in "< 1 %"), the unit whatever follows it after a space. A text with nothing after
 * its last digit, or no digit at all ("2.476", "–"), is all number.
 */
export interface MiraValueUnit {
  number: string;
  unit: string;
}

export function splitValueUnit(text: string): MiraValueUnit {
  const match = /^(.*\d)\s+(\D+)$/.exec(text);
  return match ? { number: match[1], unit: match[2] } : { number: text, unit: "" };
}
